var render = function render(){var _vm=this,_c=_vm._self._c;return _c('email-form-modal',{attrs:{"modal-id":_vm.modalId,"title":"Email Work Order Profitability Report","help-text":"Enter one or more emails to send the report to","initial-emails":_vm.email ? [_vm.email] : null,"request":_vm.submitRequest}})
}
var staticRenderFns = []

export { render, staticRenderFns }